import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../atoms/Icon'
import { pluralize } from '../../../../../utils'
import { resolveSupplementalBadgeIconName } from './badgeDisplay'

function StatusReportSupplementalRowBadge ({ count, badge }) {
  if (badge?.show !== true) return null
  const iconName = resolveSupplementalBadgeIconName(badge.icon)
  const label = badge.label || 'item'

  return (
    <div
      className='flex items-center gap-xs font-size-xs'
      style={badge.style}
    >
      <Icon name={iconName} customSize='1em' />
      <span style={{ lineHeight: '1em' }}>{count} {pluralize(count, label)}</span>
    </div>
  )
}

StatusReportSupplementalRowBadge.propTypes = {
  count: PropTypes.number.isRequired,
  badge: PropTypes.shape({
    show: PropTypes.bool,
    icon: PropTypes.string,
    style: PropTypes.object,
    label: PropTypes.string
  })
}

export default StatusReportSupplementalRowBadge
